import NoticeEditBoard from "../../components/Notice/NoticeEditBoard";
import TitleBox from "../../components/Common/TitleBox";

function NoticeEdit() {
  return (
    <div>
      <TitleBox title="전사 공지" />
      <NoticeEditBoard />
    </div>
  );
}

export default NoticeEdit;
